<template>

  <div>
    <creating
      v-if="creating"
      height="50px" />

    <ul
      class="list-group"
      v-if="!creating">
      <li
        class="list-group-item"
        v-for="(item, index) in shares"
        :key="index">
        <CandidateShareListItem :share="item" />
      </li>
    </ul>
  </div>

</template>

<script>
import CandidateShareListItem from './CandidateShareListItem'

export default {
  name: 'CandidateShareList',
  components: {
    CandidateShareListItem
  },
  props: [
  ],
  data () {
    return {
      creating: true
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    onlyThisJob () {
      return this.$store.getters.getCandidateOnlyThisJob
    },
    shares () {
      return this.$store.getters.getShareCandidates
    }
  },
  watch: {
    'selectedJob._id': function (val) {
      this.loadShares()
    },
    onlyThisJob: function (val) {
      this.loadShares()
    }
  },
  created () {
    this.loadShares()
  },
  methods: {
    /*
    loadShares
    */
    loadShares () {
      this.creating = true

      const params = {
        candidates: this.candidate._id,
        sort: '-created_at'
      }

      if (this.selectedJob && this.onlyThisJob) {
        params.job_id = this.selectedJob._id
      }

      this.$store
      .dispatch('selectShareCandidates', params)
      .then((response) => {
        this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Share/CandidateShareList.vue